var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "job-list" }, [
    _c(
      "div",
      { staticClass: "job-list__filters" },
      [
        _c("FormInputSelect", {
          attrs: {
            id: "job-filter-brand",
            label: _vm.$t("jobs.filter.brand"),
            options: _vm.brandOptions,
          },
          model: {
            value: _vm.filters.brand,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "brand", $$v)
            },
            expression: "filters.brand",
          },
        }),
        _vm._v(" "),
        _c("FormInputSelect", {
          attrs: {
            id: "job-filter-canton",
            label: _vm.$t("jobs.filter.canton"),
            options: _vm.cantonOptions,
          },
          model: {
            value: _vm.filters.canton,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "canton", $$v)
            },
            expression: "filters.canton",
          },
        }),
        _vm._v(" "),
        _c("FormInputSelect", {
          attrs: {
            id: "job-filter-work-area",
            label: _vm.$t("jobs.filter.workArea"),
            options: _vm.workAreaOptions,
          },
          model: {
            value: _vm.filters.workArea,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "workArea", $$v)
            },
            expression: "filters.workArea",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "job-list__jobs" },
      [
        _vm._l(_vm.filteredJobs, function (job, index) {
          return _c("li", { key: job.id, staticClass: "job-list__job" }, [
            _c(
              "a",
              {
                staticClass: "job-list__job-link",
                attrs: { href: job.url, target: "_blank" },
              },
              [
                _c("figure", { staticClass: "job-list__job-image" }, [
                  _c("img", {
                    staticClass: "job-list__job-image-element",
                    attrs: {
                      src: job.image,
                      width: "428",
                      height: "428",
                      alt: job.title,
                      loading: index < 3 ? "eager" : "lazy",
                      fetchpriority: index < 3 ? "high" : null,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "job-list__job-details" }, [
                  _c("span", {
                    staticClass: "job-list__job-title",
                    domProps: { innerHTML: _vm._s(job.title) },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "job-list__job-location",
                    domProps: { innerHTML: _vm._s(job.subtitle) },
                  }),
                ]),
              ]
            ),
          ])
        }),
        _vm._v(" "),
        !_vm.filteredJobs.length
          ? _c("li", {
              staticClass: "job-list__empty",
              domProps: { innerHTML: _vm._s(_vm.$t("jobs.empty")) },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }